<template>
  <div class="navigation-tabs">
    <div :class="['switch--group', { 'project-active': isProjectConnect }]">
      <button
        :class="['btn switch--button', { active: isListingOwnerConnect }]"
        @click="navigateTo(ownerRouteName)"
      >
        Listing Owner
      </button>

      <button
        :class="['btn switch--button', { active: isProjectConnect }]"
        @click="navigateTo(projectRouteName)"
      >
        Listing Proyek
      </button>
    </div>

    <button
      v-if="showFavoriteButton"
      :class="['btn favorite--button', { active: isFavoritSaya }]"
      @click="navigateTo(favoriteRouteName)"
    >
      <v-icon class="favorite--icon">mdi-heart-outline</v-icon>
      <span>Favorit Saya</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'NavigationTabs',
  props: {
    variant: {
      default: 'list',
    },
    showFavoriteButton: {
      default: true,
    },
  },

  computed: {
    ownerRouteName() {
      return this.variant === 'favorite' ? 'shortlist' : 'owner-connect';
    },

    projectRouteName() {
      return this.variant === 'favorite' ? 'shortlist-project-connect' : 'project-connect';
    },

    favoriteRouteName() {
      return this.isProjectConnect ? 'shortlist-project-connect' : 'shortlist';
    },

    isListingOwnerConnect() {
      if (this.variant === 'favorite') return this.$route.name === 'shortlist';
      return this.$route.name === 'owner-connect' || this.$route.name === 'shortlist';
    },

    isFavoritSaya() {
      return this.$route.name === 'shortlist' || this.$route.name === 'shortlist-project-connect';
    },

    isProjectConnect() {
      if (this.variant === 'favorite') return this.$route.name === 'shortlist-project-connect';
      return (
        this.$route.name === 'project-connect' || this.$route.name === 'shortlist-project-connect'
      );
    },
  },

  methods: {
    navigateTo(routeName) {
      if (this.$route.name !== routeName) {
        this.$router.push({ name: routeName });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/utils/variables';

.navigation-tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  width: 100%;
  background: transparent;
  padding: 4px 0 18px;
  margin-bottom: 6px;
  @media #{$phones, $tablets} {
    align-items: stretch;
    flex-direction: column;
    padding: 12px 0;
  }
}

.switch--group {
  --switch-gap: 4px;
  --switch-pad-x: 5px;
  --switch-pad-y: 5px;

  position: relative;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  width: auto;
  min-width: 356px;
  max-width: 420px;
  padding: var(--switch-pad-y) var(--switch-pad-x);
  border: 1px solid #e6e6e6;
  border-radius: 14px;
  background: #f7f7f7;
  gap: var(--switch-gap);
  overflow: hidden;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);

  &::before {
    content: '';
    position: absolute;
    top: var(--switch-pad-y);
    bottom: var(--switch-pad-y);
    left: var(--switch-pad-x);
    width: calc((100% - (var(--switch-pad-x) * 2) - var(--switch-gap)) / 2);
    border: 1px solid #e8e8e8;
    border-radius: 11px;
    background-color: #ffffff;
    box-shadow: 0 8px 18px rgba(30, 30, 30, 0.07);
    transform: translateX(0);
    transition: transform 0.28s ease;
  }

  &.project-active::before {
    transform: translateX(calc(100% + var(--switch-gap)));
  }

  @media #{$phones, $tablets} {
    --switch-pad-x: 8px;
    --switch-pad-y: 8px;

    width: 100%;
    min-width: 0;
  }
}

.switch--button {
  background-color: transparent;
  border: none;
  min-height: 38px;
  padding: 8px 16px;
  border-radius: 11px;
  font-family: Poppins-SemiBold, sans-serif;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: color 0.24s ease;
  color: #777777;
  margin-right: 0;
  position: relative;
  z-index: 1;
  @media #{$phones, $tablets} {
    font-size: 13px;
    padding: 8px 10px;
  }

  &:hover {
    color: #242424;
  }

  &.active {
    background-color: $color-beliruma-1;
    color: #eeeeee;
  }
}

.favorite--button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 42px;
  border: 1px solid #e6e6e6;
  border-radius: 14px;
  background: #ffffff;
  color: #333333;
  padding: 0 16px;
  font-family: Poppins-SemiBold, sans-serif;
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
  box-shadow: 0 10px 22px rgba(30, 30, 30, 0.06);
  transition: border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  .favorite--icon {
    color: #d5121b;
    font-size: 18px;
  }

  &.active,
  &:hover {
    border-color: rgba(213, 18, 27, 0.28);
    color: #d5121b;
    box-shadow: 0 12px 24px rgba(213, 18, 27, 0.1);
    transform: translateY(-1px);

    .favorite--icon {
      color: #d5121b;
    }
  }

  @media #{$phones, $tablets} {
    justify-content: center;
    font-size: 13px;
    padding: 10px 12px;

    .favorite--icon {
      font-size: 20px;
    }
  }
}
</style>
